import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=5d73aa02&"
import script from "./CompanyCard.vue?vue&type=script&lang=ts&"
export * from "./CompanyCard.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
